import { HashRouter } from 'react-router-dom'
import { GlobalStyles } from './styles/GlobalStyles'
import { theme } from './styles/theme'
import { ThemeProvider } from 'styled-components'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import Hero from './components/sections/Hero'
import Features from './components/sections/Features'
import Trailer from './components/sections/Trailer'
import About from './components/sections/About'
import Testimonials from './components/sections/Testimonials'

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <HashRouter>
        <Navbar />
        <main>
          <Hero />
          <Features />
          <Trailer />
          <About />
          <Testimonials />
        </main>
        <Footer />
      </HashRouter>
    </ThemeProvider>
  )
}

export default App
